"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var SHIPPING_METHOD_NOT_AVAILABLE = "Carrier with such method not found: %1, %2";
var PAYMENT_METHOD_NOT_AVAILABLE = "The requested Payment Method is not available.";
var PAYMENT_METHOD_ERROR = "Error with payment method, please select a different payment method.";
var useErrorCheckout = function useErrorCheckout() {
  var translations = {
    shippingMethod: (0, _langLibrary["default"])("This method is not available"),
    dontShip: (0, _langLibrary["default"])("We don't ship to this country, sorry"),
    payment: (0, _langLibrary["default"])("This method is not available"),
    paymentError: (0, _langLibrary["default"])("Error with payment method"),
    billing: (0, _langLibrary["default"])("Fill in the delivery details")
  };
  return {
    checkError: function checkError(error) {
      switch (error) {
        case SHIPPING_METHOD_NOT_AVAILABLE:
          return {
            shippingMethod: translations.shippingMethod,
            shippingAddress: {
              country: translations.dontShip
            }
          };
          break;
        case PAYMENT_METHOD_NOT_AVAILABLE:
          return {
            paymentMethod: translations.payment
          };
        case PAYMENT_METHOD_ERROR:
          return translations.paymentError;
        case useErrorCheckout.ADDRESS_NOT_SET:
          return translations.billing;
        default:
          return error;
      }
    }
  };
};
useErrorCheckout.ADDRESS_NOT_SET = "Address not set";
var _default = useErrorCheckout;
exports["default"] = _default;